import React from "react";
import { cn } from "@/lib/utils/cn";

interface SponsoredContentProps {
  title: string;
  description: string;
  sponsorName: string;
  href?: string;
  className?: string;
}

export function SponsoredContent({ title, description, sponsorName, href = "#", className }: SponsoredContentProps) {
  return (
    <div className={cn("relative", className)}>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-[10px] font-semibold tracking-[0.15em] uppercase text-muted-foreground">
          Sponsored
        </span>
        <span className="text-[10px] text-muted-foreground">·</span>
        <span className="text-[10px] text-muted-foreground">{sponsorName}</span>
      </div>
      <a
        href={href}
        className="group block p-5 rounded-lg border border-border bg-card hover:border-border/80 transition-colors duration-150"
      >
        <h4 className="text-sm font-medium text-foreground group-hover:text-primary transition-colors line-clamp-1">
          {title}
        </h4>
        <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed line-clamp-2">
          {description}
        </p>
      </a>
    </div>
  );
}
